export default "../img/bg-inner-page-2.png";